import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import {Modal} from 'react-bootstrap';

let source = axios.CancelToken.source();

class Report7day extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            moving: 0,
            movingpre: 0,
            staion: 0,
            staionpre: 0,
            unknown: 0,
            unknownpre: 0,
            main: 0,
            mainpre: 0,
            movingdatas: [],
            arriveddatas:[],
            arriveddetdatas:[],
            unknownvehicles:[],
            vehicles:[],
            gk: 0,
            def: 0,
            mid: 0,
            att: 0,
            gkpre: 0,
            defpre: 0,
            midpre: 0,
            attpre: 0,

            //modal
            movingdetshow: false,
            type: '',
            msg:'',
            headings:[],
            headingexe:false,

            //modal2
            arriveddetshow:false,
        }
    }
    componentDidMount() {
        let baseurl = myconfig.reportsevenday;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    render() {
        return (
            <>
                <div className="min-height-300 bg-primary position-absolute w-100"></div>
                <div className={this.state.menu}>
                    <Nav type="home"/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky " id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a className="opacity-5 text-white" href="#">Dashboard</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">Heading</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="true" /></span>
                                            <input type="text" className="form-control" placeholder="Type here..." />
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="" className="nav-link text-white font-weight-bold px-0">
                                                <i className="fa fa-user me-sm-1" />
                                                <span className="d-sm-inline d-none">ncapi</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" onClick={this.menuhidden}>
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                            <div className="card  mb-4">
                                <div className="card-body p-3">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p>ZTS Ethiopia</p>
                                            <p> 7-Day Dashboard</p>
                                            <p>From 12/06/2021-12/12/2021</p>
                                        </div>
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <img className="img img-ss w-50" src="img\ztsheader.png"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

            </>
        )
    }
}

export default Report7day;
